<template>
    <v-container fluid>
        <template v-if="setting">
            <settings-form
                :setting="setting"
                :titlePrefix="$t('forms.title_prefix.edit')"
                @saved="saved"
            />
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import SettingsForm from './Form'
import Setting from '@/models/Setting'

export default {
    props: {
        id: {
            required: true,
        },
    },

    components: {
        SettingsForm,
    },

    data: () => {
        return {
            setting: null,
        }
    },

    methods: {
        async getSetting() {
            let setting = await new Setting().find(this.id)
            this.setting = setting
        },

        saved() {
            this.$router.push({ name: 'settings.index' })
        },
    },

    created() {
        this.getSetting()
    },
}
</script>

<style></style>
